import React from 'react';
import PropTypes from 'prop-types';

const Barcode = ({ outlineColor, s: { width, height } = {} }) => (
  <svg
    viewBox="0 0 64 64"
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.691 8a.99.99 0 0 1 0 1.98H9.382a2.403 2.403 0 0 0-2.403 2.402v10.744a.99.99 0 0 1-1.979 0V12.382A4.382 4.382 0 0 1 9.382 8h11.31Zm21.628.99a.99.99 0 0 1 .99-.99h11.309A4.382 4.382 0 0 1 59 12.382v10.744a.99.99 0 0 1-1.98 0V12.382a2.403 2.403 0 0 0-2.402-2.403h-11.31a.99.99 0 0 1-.989-.99ZM15.885 21.288a.99.99 0 0 0-1.98 0v20.639a.99.99 0 0 0 1.98 0V21.288Zm6.785 0a.99.99 0 0 0-1.979 0v20.639a.99.99 0 0 0 1.98 0V21.288Zm5.796-.99a.99.99 0 0 1 .99.99v20.639a.99.99 0 0 1-1.98 0V21.288a.99.99 0 0 1 .99-.99Zm7.775.99a.99.99 0 1 0-1.98 0v20.639a.99.99 0 0 0 1.98 0V21.288Zm12.581-.99a.99.99 0 0 1 .99.99v20.639a.99.99 0 0 1-1.98 0V21.288a.99.99 0 0 1 .99-.99Zm-5.796.99a.99.99 0 0 0-1.979 0v20.639a.99.99 0 0 0 1.98 0V21.288Zm-.707 33.503c0 .546.444.99.99.99h11.309A4.382 4.382 0 0 0 59 51.397V40.654a.99.99 0 0 0-1.98 0v10.744a2.403 2.403 0 0 1-2.402 2.403h-11.31a.99.99 0 0 0-.989.99Zm-21.628.99a.99.99 0 0 0 0-1.98H9.382a2.403 2.403 0 0 1-2.403-2.403V40.654a.99.99 0 1 0-1.979 0v10.744a4.382 4.382 0 0 0 4.382 4.382h11.31Z"
      fill={outlineColor}
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

Barcode.defaultProps = {
  outlineColor: '#000000',
  s: {},
};

Barcode.propTypes = {
  outlineColor: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
  }),
};

export default Barcode;
